import { settingsScreen } from "./settings.ts";
export function connectScreen(): HTMLElement { return settingsScreen(true); }
